<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">

            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================-->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Versicherungsnehmer</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_anrede" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        Geben Sie den <b>Namen</b> an, auf welchen die Versicherung abgeschlossen werden soll.
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_vorname" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_nachname" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        Hier benötigen wir Ihr <b>Geburtsdatum.</b>
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_geburtsdatum" v-model="value.fieldValues"
                                           :disabled="$store.state.rechnerConfig.rechnerInfo.name==='privat'"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        Tragen Sie hier die <b>Straße</b> ein, an die die Versicherungsunterlagen gesandt werden sollen.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_strasse" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        <b>PLZ</b> und <b>Ort</b> angeben, an die die Versicherungsunterlagen gesandt werden sollen.
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_plz" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_ort" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        <div>
                            Die Angabe einer <b>Telefonnummer</b> ist optional.
                        </div>
                        <div style="border-top:1px solid #ccc">
                            Die Angabe einer aktuellen <b>E-Mail-Adresse</b>
                            ist für den Online Abschluss der Versicherung dringend erforderlich!
                        </div>
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_telefon" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.versnehm_email" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import slideMixin from '../stepMixin'
    import _ from 'lodash'

    //import {mapState} from 'vuex'

    export default {
        //========================================================================================================
        data: function () {

            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}

            return {
                fieldDefs: fieldDefs_OVERRIDE,


            }
        }, //========================================================================================================
        name: 'Step_VersNehmer',
        label: 'Versicherungsnehmer',
        label2: 'Versicherungs-<br>nehmer',
        fieldKeys: [
            'vertrag_beginn',
            'versnehm_anrede',
            'versnehm_nachname',
            'versnehm_vorname',
            'versnehm_geburtsdatum',
            'versnehm_strasse',
            'versnehm_plz',
            'versnehm_ort',
            'versnehm_telefon',
            'versnehm_email',
        ],
        //========================================================================================================
        watch: {
            value: {
                handler: function (newVal, oldVal) {
                    console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
                    console.log("WATCHER fieldValues in ", this.$options.label)
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld
                    var earlyExit = true;
                    for (var key in fV) {
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            console.log("changed ", key, fVold[key], '->', fV[key])

                            this.update_Ort_by_PLZ(key)
                        }
                    }
                    if (earlyExit === true) {
                        console.log("NO changes -> early EXIT")
                        return;
                    }

                    var abschluss_antrag_an_email = this.allSteps.Step_Abschluss.fieldValues.abschluss_antrag_an_email
                    /*------------------------------------------------------------------------------------*/
                    if (!(abschluss_antrag_an_email > '') && fV.versnehm_email !== fVold.versnehm_email) {
                        this.allSteps.Step_Abschluss.fieldValues.abschluss_antrag_an_email = fV.versnehm_email
                        console.log("set abschluss_antrag_an_email = versnehm_email")
                    }
                    /*------------------------------------------------------------------------------------*/
                    this.frmValuesOld = _.assign({}, fV)
                },
                deep: true,

            },
        }, //===============================================================================================
        mixins: [slideMixin],
        //===========================================================================================================
        components: {/* programmatically setted by step-mixin*/},
        //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        // HOOKS:
        /* programmatically setted by step-mixin*/

        beforeUpdate: function () {
            if (this.activeStepNr == this.myStepNr) {
                console.log("!!! Set 'vertrag_beginn' to value setted in first step")

                //einsammeln aller Feld-Werte die vor diesem Step gesetzt wurden:
                var values = {};
                _.forEach(this.allSteps, (step, stepName) => {
                    if (stepName === 'Step_VersNehmer') {
                        return
                    }
                    values = _.assign({}, step.fieldValues, values)
                })

                //setzen des Wertes von 'vertrag_beginn' in diesem Step mit dem Wert bereits in einem vorherigem Step gesetzt wurde:
                //!!! ACHTUNG : das autom. füllen mit testDaten überschreibt diese Aktion wieder erneut mit dem Wert aus dem Test-Datensatz
                this.value.fieldValues.vertrag_beginn = values.vertrag_beginn

            }
        }

        //===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
